<template>
	<MainLayout>
		<div class="container">
			<b-card>
				<b-row>
					<b-col lg="6">
						<h2>Perfiles</h2>
					</b-col>
					<b-col lg="6">
						<b-button
							v-if="$hasPermission('profile.add')"
							class="float-right"
							@click.prevent="newItem"
							>Nuevo perfil</b-button
						>
					</b-col>
				</b-row>

				<hr />
				<b-form
					@submit="
						evt => {
							evt.preventDefault();
							this.$root.$emit(
								'bv::refresh::table',
								'profiles-index-list'
							);
						}
					"
				>
					<div class="row">
						<b-form-group class="col-2" label="Buscar">
							<b-form-input
								v-model="filters.search"
								type="text"
							/>
						</b-form-group>
						<b-form-group class="col-2" label=".">
							<b-button type="submit" variant="primary"
								>Buscar</b-button
							>
						</b-form-group>
					</div>
				</b-form>

				<AjaxTable
					permission-show="profile.show"
					id="profiles-index-list"
					:filters="filters"
					:columns="columns"
					resource="profiles"
					responsive
				>
					<template v-slot:cell(actions)="row">
						<div class="text-center">
							<b-button
								@click="
									() => editProfile(row.item.id)
								"
								type="button"
								size="sm"
								class="mr-1"
								variant="info"
							>
								<md-icon icon="edit" />
							</b-button>
							<b-button
								v-if="$hasPermission('profile.permission.show')"
								@click="() => editPermissions(row.item)"
								type="button"
								size="sm"
								class="mr-1"
								variant="primary"
							>
								<md-icon icon="lock" />
							</b-button>
							<b-button
								v-if="$hasPermission('profile.delete')"
								@click="
									event =>
										itemDelete(row.item, row.index, event)
								"
								type="button"
								size="sm"
								class="mr-1"
								variant="danger"
							>
								<md-icon icon="delete" />
							</b-button>
						</div>
					</template>
				</AjaxTable>

				<Single :unableEdit="unableEdit" ref="single" :success-callback="successCallback" />
				<SinglePermissions
					:unableEdit.sync="unableEditPermission"
					ref="singlePermissions"
					:success-callback="successCallback"
				/>
			</b-card>
		</div>
	</MainLayout>
</template>

<script>
import MainLayout from "../layout/MainLayout.vue";
import AjaxTable from "../../helpers/AjaxTable.vue";
import Single from "./Single.vue";
import SinglePermissions from "./SinglePermissions.vue";
import api from "../../../api.js";

export default {
	components: { MainLayout, AjaxTable, Single, SinglePermissions },
	data() {
		return {
			unableEdit: false,
			unableEditPermission: false,
			filters: {},
			columns: [
				{ key: "id", label: "ID" },
				{ key: "name", label: "Nombre" },
				{ key: "description", label: "Descripción" },
				{ key: "actions", label: "Acciones" }
			]
		};
	},
	methods: {
		successCallback() {
			this.$root.$emit("bv::refresh::table", "profiles-index-list");
		},
		editProfile(id){
			this.unableEdit = !this.$hasPermission("profile.edit");
			this.$refs['single'].loadModel(id)
		},
		editPermissions(item) {
			this.unableEditPermission = !this.$hasPermission("profile.permission.edit");
			this.$refs["singlePermissions"].loadModel(item.id, item.name);
		},
		itemDelete(item) {
			this.$root.showWarning({
				okAction: (event, setLoading, close) => {
					setLoading(true);
					api(this)
						.delete(`/profiles/${item.id}`)
						.then(() => {
							this.$root.showAlert("Perfil Eliminado!", {
								variant: "warning"
							});
							this.$root.$emit(
								"bv::refresh::table",
								"profiles-index-list"
							);
							close();
						})
						.catch(err => {
							this.$root.handleRequestError(err);
							close();
						});
				}
			});
		},
		newItem() {
			this.$refs["single"].loadModel();
		}
	},
	computed: {},
	mounted() {}
};
</script>
